const styles = theme => ({
    grid: {
        margin: "0 -15px !important",
        width: "unset"
    }
});
    
export default styles;